import { render, staticRenderFns } from "./outsource-commission.vue?vue&type=template&id=15412aa8"
import script from "./outsource-commission.vue?vue&type=script&lang=ts"
export * from "./outsource-commission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports